<div class="cManikPopupWidth">
    <div class="main-content">
        <div class="cPopupContainer">
            <div [ngClass]="{'cPopupSidebar': HModel.ShowSectionList,'cPopupSidebarNarrow': !HModel.ShowSectionList}">
                <div class="cPopupMenu1">
                    <ul class="nav">
                        <li>
                            <a matTooltip="Page settings" [matTooltipPosition]="'right'"
                                (click)="PopulateMenu2('Page')">
                                <i class="fa fa-file-text" [ngClass]="{'active': HModel.IsPageSettingActive}"></i>
                            </a>
                        </li>
                    </ul>
                    
                    <ul class="nav cPopupLowerUL">
                        <li >
                            <a matTooltip="SEO" [matTooltipPosition]="'right'"
                                (click)="PopulateMenu2('SEO')">
                                <i class="fa fa-search" [ngClass]="{'active': HModel.IsSOEActive}"></i>
                                <!-- <i class="material-icons" [ngClass]="{'active': HModel.IsSOEActive}">pages</i> -->
                            </a>
                        </li>
                        <li *ngIf="HModel.EditBackground">
                            <a matTooltip="Background" [matTooltipPosition]="'right'"
                                (click)="PopulateMenu2('Background')">
                                <i class="material-icons" [ngClass]="{'active': HModel.IsBackgroundActive}">pages</i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                [ngClass]="{'cPopupMainPanel': HModel.ShowSectionList, 'cPopupMainPanelExpanded cSiteSettingExpand': !HModel.ShowSectionList}">
                <div class="cPopupWorkSpace" [hidden]="!HModel.ShowPageSettings">
                    <microsite-settings [SettingsView]="'P'" [EditOption]="EditOption"></microsite-settings>
                </div>
                <div class="cPopupWorkSpace" [hidden]="!HModel.ShowBackgroundSettings">
                    <microsite-settings [SettingsView]="'B'" [EditOption]="EditOption"></microsite-settings>
                </div>
                <div class="cPopupWorkSpace" [hidden]="HModel.ShowBackgroundSettings || HModel.ShowPageSettings">
                    <microsite-settings [SettingsView]="'S'" [EditOption]="EditOption"></microsite-settings>
                </div>
            </div>
        </div>
    </div>
</div>